import { __extends } from "tslib";
import { FederatedMouseEvent } from './FederatedMouseEvent';

var FederatedWheelEvent =
/** @class */
function (_super) {
  __extends(FederatedWheelEvent, _super);

  function FederatedWheelEvent() {
    var _this = _super !== null && _super.apply(this, arguments) || this;
    /** Units specified in lines. */


    _this.DOM_DELTA_LINE = 0;
    /** Units specified in pages. */

    _this.DOM_DELTA_PAGE = 1;
    /** Units specified in pixels. */

    _this.DOM_DELTA_PIXEL = 2;
    return _this;
  }

  return FederatedWheelEvent;
}(FederatedMouseEvent);

export { FederatedWheelEvent };